import styled from "vue-styled-components";

export const CPageWrapper = styled.div`
    font-family: ${props => props.theme?.font_family ?? 'Open Sans'};
    background: ${props => props.theme?.background_color_site ?? '#ffffff'};
`

export const CSliderRating = styled.div`
    padding: 2rem;
    margin: 10px;
    border-radius: 0.3rem;
    box-shadow: 0 0 10px ${props => props.theme?.home_page?.carousel?.shadow_color ?? '#f0f0f0'};
    position: relative;
    top: 50%;
    transform: translateY(-52%);

    .slide-informations {
        padding-bottom: 5px;
        border-bottom: 1px solid ${props => props.theme?.home_page?.carousel?.border_color ?? '#f0f0f0'};
        .user-informations {
            display: flex;
            justify-content: space-between;
            flex-direction: row;
            h3 {
                text-transform: capitalize;
                text-overflow: ellipsis;
                display: block;
                width: 70%;
                white-space: nowrap;
                margin-bottom: 0px;
                overflow: hidden;
                font-size: 1.5rem;
                font-weight: 500;
                color: ${props => props.theme?.home_page?.carousel?.color_title ?? '#2b2b2d'};
            }
            .slide-rating {
                margin-top: -5px;
            }
        }
        small {
            display: block;
            margin-top: 3px;
            text-transform: ${props => props.theme?.products?.text_transform ?? 'uppercase'};
            color: ${props => props.theme?.home_page?.carousel?.color_text ?? '#4a505e'};
        }
    }
    .slide-title {
        margin-bottom: 0;
        color: ${props => props.theme?.home_page?.carousel?.color_title ?? '#2b2b2d'};
        font-weight: 700;
        font-size: 1.4rem;
    }
    .slide-comment {
        span {
            color: ${props => props.theme?.home_page?.carousel?.color_text ?? '#4a505e'};
        }
        &.limited {
            span {
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 5;
                line-clamp: 5;
                -webkit-box-orient: vertical;
            }
           p.read-more-comment {
                display: inline-block;
                color: ${props => props.theme?.home_page?.carousel?.color_title ?? '#2b2b2d'};
                font-weight: 600;
                cursor: pointer;
                margin-top: 3px;
                &:hover {
                    text-decoration: underline;
                }
            }
        }
        p.read-more-comment {
            display: none;
        }
    }

    @media (max-width: 800px) {
        padding: 1.2rem;
        margin: 5px;
    }

    @media (max-width: 400px) {

        .slide-informations {
            .user-informations {
                flex-direction: column;
                h3 {
                    margin-bottom: 6px;
                    width: 100%;
                }
            }
        }
    }
`

export const CSidebarAccount = styled.ul`
    li {
        a {
            border-bottom: 1px solid ${props => props.theme?.my_account?.sidebar?.border_color ?? '#EDEDDE'};
            color: ${props => props.theme?.my_account?.sidebar?.color ?? '#4a505e'};
            &:hover, &:focus {
                background-color: transparent;
                opacity: 0.7;
            }
            &:before {
                border-left: 4px solid ${props => props.theme?.my_account?.sidebar?.color ?? '#4a505e'};
            }
        }
        &.active {
            a {
                pointer-events: none;
                color: ${props => props.theme?.my_account?.sidebar?.color_active ?? '#2b2b2d'};
                &:before {
                    border-left: 4px solid ${props => props.theme?.my_account?.sidebar?.color_active ?? '#2b2b2d'};
                }
            }
        }
    }
`

export const CCardAccount = styled.div`

    .card-header {
        background-color: ${props => props.theme?.my_account?.cards?.background_color_header ?? '#f5f5f5'};
        color: ${props => props.theme?.my_account?.cards?.color_header ?? '#2b2b2d'};

        a {
            color: ${props => props.theme?.my_account?.cards?.color_header ?? '#2b2b2d'};
        }
    }

    .card-body {
        background-color: ${props => props.theme?.my_account?.cards?.background_color_body ?? '#fff'};
        margin: 0 0 20px 0;
        border-radius: 6px;
        span, p, a, strong {
            color: ${props => props.theme?.my_account?.cards?.color_body ?? '#000'};

        }
    }
`

export const CModalContent = styled.div`
    background-color: ${props => props.theme?.background_color_site ?? '#ffffff'};
    .product-quick-view {
        background-color: ${props => props.theme?.background_color_site ?? '#ffffff'};
    }
    .modal-header, .modal-footer {
        border-color: ${props => props.theme?.border_color_site ?? '#e9ecef'};
    }
    .modal-header {
        .close, .close:hover {
            color: ${props => props.theme?.text_site_color ?? '#000'};
        }
    }
`

export const CContentFormRegister = styled.div`
    span.stepTitle {
        color: ${props => props.theme?.text_site_color ?? '#4a505e'};
    }
    .vue-form-wizard {
        .wizard-nav-pills > li > a {
            color: ${props => props.theme?.text_site_color ?? '#4a505e'};
        }
        .wizard-icon-circle {
            background-color: ${props => props.theme?.background_color_site ?? '#ffffff'};
            border: 3px solid ${props => props.theme?.text_site_color ?? '#f3f2ee'};
        }
    }
`

export const CWidgetFeatured = styled.div`
    h3.widget-title {
        color: ${props => props.theme?.titles_site_color ?? '#2b2b2d'};
    }

    > .widget-body {
        button.owl-prev,
        button.owl-next {
            color: ${props => props.theme?.titles_site_color ?? '#2b2b2d'} !important;
        }
    }
`

export const CTotalPagination = styled.label`
    color: ${props => props.theme?.pagination?.total_pagination?.color ?? '#4A505E'} !important;
    font-size: ${props => props.theme?.pagination?.total_pagination?.font_size ?? '1.3rem'} !important;
    font-weight: ${props => props.theme?.pagination?.total_pagination?.font_weight ?? '400'} !important;
`

export const CPagination = styled.nav`
    border-top: 1px solid ${props => props.theme?.pagination?.border_color_div ?? '#e4e4e4'} !important;
`

export const CPaginationItem = styled.li`
    background-color: transparent;
    width: 3.6rem;
    height: 3.6rem;
    transition: all .3s;
    font-size: ${props => props.theme?.pagination?.font_size ?? '1.5rem'};
    font-weight: ${props => props.theme?.pagination?.font_weight ?? '600'};
    border-radius: ${props => props.theme?.pagination?.border_radius ?? '0'};
    &:hover {
        background-color: ${props => props.theme?.pagination?.background_color_hover ?? '#eee'};
        a {
            color: ${props => props.theme?.pagination?.color_hover ?? '#4a505e'}
        }
    }
    &.active {
        pointer-events: none;
        background-color: ${props => props.theme?.pagination?.background_color_active ?? props.theme.primary_color};
        a {
            color: ${props => props.theme?.pagination?.color_active ?? '#fff'}
        }
    }
    > a {
        color: ${props => props.theme?.pagination?.color ?? '#4a505e'};
        background-color: transparent;
        border-color: transparent;
        cursor: pointer;
        text-decoration: none;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 3.6rem;
        height: 3.6rem;
        padding: 0;
        line-height: 1.25;
        position: relative;
        transition: all .3s;
    }
    > a.arrow-page {
        background-color: ${props => props.theme?.pagination?.background_color_active ?? props.theme.primary_color};
        color: ${props => props.theme?.pagination?.color_active ?? '#fff'};
        border-radius: ${props => props.theme?.pagination?.border_radius ?? '0'};
    }
    &.disabled {
        pointer-events: none;
        > a.arrow-link {
            opacity: 0.7;
        }
    }
    > span {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 3.6rem;
        height: 3.6rem;
        padding: 0;
        color: ${props => props.theme?.pagination?.color ?? '#4a505e'};
    }
`

const propsCContainer = {
    flexFlow: {
        default: 'column',
        type:String
    }
}

export const CContainer= styled('div', propsCContainer)`
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;


    @media (min-width: 576px) {
        max-width: 540px;
    }

    @media (min-width: 768px) {
        max-width: 720px;
    }

    @media (min-width: 992px) {
        max-width: 100%;
    }

    @media (min-width: 1200px) {
        max-width: 1140px;
    }

    @media (min-width: 1280px) {
        max-width: 1200px;
    }

    @media (max-width: 991px) {
        max-width: 100%;
    }

    @media (max-width: 581px) {
        flex-flow: ${props => props.flexFlow};
    }
`;

export const CContainerFluid= styled.div`
    width: 100%;
    margin-right: auto;
    margin-left: auto;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;

    @media (min-width: 991px){
        max-width: 100%;
    }

    @media (min-width: 1280px){
        max-width: 1200px;
    }

`;

export const CFloatingWhatsapp = styled.div`
    position: fixed;
    z-index: 999;
    bottom: ${props => props.theme?.whatsapp_icon?.bottom ?? '55px'};
    ${props => (props.theme?.whatsapp_icon?.local ?? 'right') == 'right' ? 'right: 13.5px;' : 'left: 13.5px;'}
    width:60px;
    height: 45px;
    display:flex;
    align-items: center;
    justify-content: center;
    > a {
        border-radius: 50%;
        display: inline-flex;
        -ms-flex-align: center;
        align-items: center;
        -ms-flex-pack: center;
        justify-content: center;
        width: 60px;
        height: 60px;
        background-color: #299D0F;
        color: #fff;
        font-size: 4rem;
        text-decoration: none;
        opacity: 1;
        cursor:pointer;

        > i {
            font-family:'Font Awesome 5 Brands';
            &:before {
                display: inline-block;
                content: '\\f232';
                font-style: normal;
            }
        }

        &:hover {
            background-color: #008200;
        }
    }

`;

export const CFloatingShippingTime = styled.div`
    position: fixed;
    z-index: 999;
    bottom: 50%;
    right: 13.5px;
    width:45px;
    height: 45px;
    display:flex;
    align-items: center;
    justify-content: flex-end;
    background-color: #fa4a4a;
    border-radius: 8px;
    transition-duration: 0.5s;
    transition: width 1s;
    overflow:hidden;
    font-family: ${props => props.theme?.font_family ?? 'Open Sans'}, sans-serif;
    > a {

        display: inline-flex;
        -ms-flex-align: center;
        align-items: center;
        -ms-flex-pack: center;
        justify-content: center;
        width: 45px;
        height: 45px;
        background-color:transparent;
        color: #fff;
        font-size: 2rem;
        text-decoration: none;
        opacity: 1;
        cursor:pointer;

        > img {
            width:16px;
            height:16px;
        }
    }
    &:hover {
        width: 350px;
        height: 45px;
        &:before {
            width: 350px;
            color:#fff;
            content: attr(data-content);
        }

    }
    &:before {
        position:absolute;
        width: 0px;
        color:transparent;
        padding:17px;
        content: '';
        font-style: normal;
    }

`;

export const CBreadcrumbItem = styled.li`
    text-transform: initial;
    display: ${props => props.theme?.show_navigation == false ? 'none' : ''};
    ${console.log('entrou na nav')}
    font: 400 1.3rem/1.4 ${props => props.theme?.font_family ?? "Open Sans"}, sans-serif;
    color: ${props => props.theme?.breadcrumb_color ?? "#000"};

    a, &:before, &.active, &.active::before {
        color: ${props => props.theme?.breadcrumb_color ?? "#000"} !important;
    }
`;

export const CPageSite = styled.div`
    color: ${props => props.theme?.text_site_color ?? '#4a505e'};
    .image-style-align-right {
        float: right;
        margin-left: 1rem;
    }

    .image-style-align-left {
        float: left;
        margin-right: 1rem;
    }

    .image-style-block-align-left {
        margin-left: 0;
    }

    .image:not(.image-style-align-right):not(.image-style-align-left) img {
        margin-top: 1rem;
        margin-bottom: 1rem;
    }

    .image:not(.image-style-block-align-left):not(.image-style-block-align-right):not(.image-style-align-right):not(.image-style-align-left) img {
        margin: 1rem auto;
    }

    .image:not(.image-style-block-align-left):not(.image-style-block-align-right):not(.image-style-align-right):not(.image-style-align-left) {
        margin: 0 auto;
    }

    .image-style-block-align-right {
        margin-right: 0;
        margin-left: auto;
    }

    // BLOCKQUOTE
    blockquote {
        overflow: hidden;
        padding-right: 1.5em;
        padding-left: 1.5em;
        margin-left: 0;
        margin-right: 0;
        font-style: italic;
        border-left: 5px solid #ccc;

        p {
            margin: 1rem 0;
        }
    }

    // TABLE
    .table {
        width: auto;
        margin: 1rem;

        table {
            margin: 0 auto;
        }
    }

    pre {
        padding: 1em;
        color: #353535;
        background: hsla(0,0%,78%,.3);
        border: 1px solid #c4c4c4;
        border-radius: 2px;
        text-align: left;
        direction: ltr;
        tab-size: 4;
        white-space: pre-wrap;
        font-style: normal;
        min-width: 200px;

        text-align: left;
        direction: ltr;
        tab-size: 4;
        white-space: pre-wrap;
        font-style: normal;

        code {
            background: unset;
            padding: 0;
            border-radius: 0;
        }
    }

    code {
        background-color: #c7c7c780;
        padding: 0.3rem;
    }

    // LISTS
    ul {
        list-style: disc;
        padding-left: 25px;

        &.todo-list {
            list-style: none;
            padding-left: 10px;

            li input {
                margin-right: 5px;
            }
        }
    }

    ol {
        list-style: decimal;
        padding-left: 25px;

        /* li::marker {
            color: #000;
        } */
    }

    // MARKERS
    .marker-blue {
        background-color: #bfe7ff;
    }

    .marker-yellow {
        background-color: #fbff89;
    }

    .marker-green {
        background-color: #bbff95;
    }

    .marker-pink {
        background-color: #ffb1c7;
    }

    // PENS
    .pen-red {
        background: transparent;
        color: red;
    }

    .pen-green {
        background: transparent;
        color: green;
    }
`

export const CInputQtd = styled.div`
    &.input-quantity-cart {
        display: flex;
        justify-content: space-between;
        width: 68px;
        > input {
            border: none;
            background: ${props => props.theme?.inputs?.background_color ?? props.theme?.background_color_site ?? '#fff'};
            color: ${props => props.theme?.inputs?.color ?? '#21293c'};
            border: 1px solid ${props => props.theme?.inputs?.border_color ?? '#e6e6e6'};
            width: 46px;
            height: 42px;
            padding: 1rem .2rem;
            font-size: 1.3rem;
            letter-spacing: .05em;
            text-align: center;
            outline: none;
            &::placeholder {
                color: ${props => props.theme?.inputs?.color ?? '#4a505e'} !important;
            }
        }
        .buttons-quantity-cart {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            > button {
                border: none;
                width: 20px;
                height: 20px;
                outline: none;
                cursor: pointer;
                background: ${props => props.theme?.inputs?.background_color ?? props.theme?.background_color_site ?? '#fff'};
                border: 1px solid ${props => props.theme?.inputs?.border_color ?? '#e6e6e6'};
                &:hover,
                &:focus {
                    background: ${props => props.theme?.inputs?.background_color ?? props.theme?.background_color_site ?? '#fff'};
                    color: ${props => props.theme?.inputs?.color ?? '#4a505e'};
                    border: 1px solid ${props => props.theme?.inputs?.border_color ?? '#e6e6e6'};
                }
                > i {
                    color: ${props => props.theme?.inputs?.color ?? '#4a505e'};
                    font-size: 1.1rem;
                }
            }
        }
    }

    &.input-quantity {
        display: flex;
        margin-bottom: 1rem;
        margin-right: 0.5rem;
        > button {
            border: none;
            width: 30px;
            height: 45px;
            outline: none;
            cursor: pointer;
            background: ${props => props.theme?.inputs?.background_color ?? props.theme?.background_color_site ?? '#fff'};
            border: 1px solid ${props => props.theme?.inputs?.border_color ?? '#e6e6e6'};
            &:hover,
            &:focus {
                background: ${props => props.theme?.inputs?.background_color ?? props.theme?.background_color_site ?? '#fff'};
                color: ${props => props.theme?.inputs?.color ?? '#4a505e'};
                border: 1px solid ${props => props.theme?.inputs?.border_color ?? '#e6e6e6'};
            }
            &.btn-quantity-minus {
                border-radius: ${props => props.theme?.inputs?.border_radius ?? '0'} 0 0 ${props => props.theme?.inputs?.border_radius ?? '0'};
            }
            &.btn-quantity-plus {
                border-radius: 0 ${props => props.theme?.inputs?.border_radius ?? '0'} ${props => props.theme?.inputs?.border_radius ?? '0'} 0;
            }
            > i {
                color: ${props => props.theme?.inputs?.color ?? '#4a505e'};
                font-size: 1.1rem;
            }
        }
        input {
            border: none;
            background: ${props => props.theme?.inputs?.background_color ?? props.theme?.background_color_site ?? '#fff'};
            color: ${props => props.theme?.inputs?.color ?? '#21293c'};
            border-top: 1px solid ${props => props.theme?.inputs?.border_color ?? '#e6e6e6'};
            border-bottom: 1px solid ${props => props.theme?.inputs?.border_color ?? '#e6e6e6'};
            width: 40px;
            height: 45px;
            padding: 1rem .2rem;
            font-size: 1.5rem;
            letter-spacing: .05em;
            text-align: center;
            outline: none;
            &::placeholder {
                color: ${props => props.theme?.inputs?.color ?? '#4a505e'} !important;
            }
        }
    }

    /* input {
        background: ${props => props.theme?.inputs?.background_color ?? props.theme?.background_color_site ?? '#fff'};
        color: ${props => props.theme?.inputs?.color ?? '#4a505e'} !important;
        border: 1px solid ${props => props.theme?.inputs?.border_color ?? '#e6e6e6'} !important;

        &::placeholder {
            color: ${props => props.theme?.inputs?.color ?? '#4a505e'} !important;
        }

        &:focus {
            background: ${props => props.theme?.inputs?.background_color ?? props.theme?.background_color_site ?? '#fff'};
            border: 1px solid ${props => props.theme?.inputs?.border_color ?? '#e6e6e6'} !important;
        }
    }

    button {
        background: ${props => props.theme?.inputs?.background_color ?? props.theme?.background_color_site ?? '#fff'};
        color: ${props => props.theme?.inputs?.color ?? '#4a505e'} !important;
        border: 1px solid ${props => props.theme?.inputs?.border_color ?? '#e6e6e6'} !important;

        &:hover,
        &:focus {
            background: ${props => props.theme?.inputs?.background_color ?? props.theme?.background_color_site ?? '#fff'};
            color: ${props => props.theme?.inputs?.color ?? '#4a505e'} !important;
            border: 1px solid ${props => props.theme?.inputs?.border_color ?? '#e6e6e6'} !important;
        }
    }

    span:not(.input-group-btn-vertical) button {
        &.btn-down-icon {
            border-radius: ${props => props.theme?.inputs?.border_radius ?? '0'} 0 0 ${props => props.theme?.inputs?.border_radius ?? '0'};
        }

        &.btn-up-icon {
            border-radius: 0 ${props => props.theme?.inputs?.border_radius ?? '0'} ${props => props.theme?.inputs?.border_radius ?? '0'} 0;
        }

        &:before,
        &:after {
            background: ${props => props.theme?.inputs?.color ?? '#4a505e'} !important;
        }
    } */
`

export const CSelectCustom = styled.div`
    > select,
    > select:focus {
        background: ${props => props.theme?.inputs?.background_color ?? props.theme?.background_color_site ?? '#fff'};
        border-color: ${props => props.theme?.inputs?.border_color ?? '#e6e6e6'} !important;
        color: ${props => props.theme?.inputs?.color ?? '#4a505e'};
        border-radius: ${props => props.theme?.inputs?.border_radius ?? '0'};
    }
    &::after {
        color: ${props => props.theme?.inputs?.color ?? '#4a505e'};
    }
`

export const CCartSummary = styled.div`
    border: 1px solid ${props => props.theme?.checkout?.border_color ?? '#ddd'};
    background: ${props => props.theme?.checkout?.background_color ?? '#fbfbfb'};

    h3 {
        color: ${props => props.theme?.checkout?.title?.color ?? '#2b2b2d'};
    }

    h4 {
        border-top: 1px solid ${props => props.theme?.checkout?.border_color ?? '#ddd'};
        color: ${props => props.theme?.checkout?.subtitle?.color ?? '#2b2b2d'};
    }

    .radio-group {
        border: 1px solid ${props => props.theme?.checkout?.border_color ?? '#ddd'};

        .forma-conteiner,
        .forma-conteiner a {
            color: ${props => props.theme?.checkout?.color ?? '#4a505e'};
        }

        .radio-heading {
            display: flex;
            line-height: normal;

            .radio-conteiner {
                float: none;
                display: flex;
                align-items: center;
                height: auto;
            }

            .forma-conteiner {
                margin: 0;
                width: 100%;
                padding-block: 0.8rem;
                line-height: 1.7;
                margin-block: auto;
            }
        }
    }

    .content-payment {
        border-left: 1px solid ${props => props.theme?.checkout?.border_color ?? '#ddd'} !important;
        border-right: 1px solid ${props => props.theme?.checkout?.border_color ?? '#ddd'} !important;
        border-bottom: 1px solid ${props => props.theme?.checkout?.border_color ?? '#ddd'} !important;
        color: ${props => props.theme?.checkout?.color ?? '#4a505e'};
    }

    .table-totals {
        border-top: 1px solid ${props => props.theme?.checkout?.border_color ?? '#ddd'};

        tbody {
            color: ${props => props.theme?.checkout?.color ?? '#4a505e'};
        }

        tfoot {
            border-top: 1px solid ${props => props.theme?.checkout?.border_color ?? '#ddd'};

            tr td:first-child {
                color: ${props => props.theme?.checkout?.color ?? '#4a505e'};
            }

            tr td:last-child {
                color: ${props => props.theme?.checkout?.subtitle?.color ?? '#2b2b2d'};
            }
        }
    }

    > form {
        input {
            background: ${props => props.theme?.checkout?.inputs?.background_color ?? '#fff'};
            border: 1px solid ${props => props.theme?.checkout?.inputs?.border_color ?? '#e6e6e6'};
            color: ${props => props.theme?.checkout?.inputs?.color ?? '#4a505e'};
            border-radius: ${props => props.theme?.checkout?.inputs?.border_radius ?? '0'};

            &::placeholder {
                color: ${props => props.theme?.checkout?.inputs?.color ?? '#4a505e'} !important;
            }

            &:focus {
                background: ${props => props.theme?.checkout?.inputs?.background_color ?? '#fff'};
                border: 1px solid ${props => props.theme?.checkout?.inputs?.border_color ?? '#e6e6e6'};
                color: ${props => props.theme?.checkout?.inputs?.color ?? '#4a505e'};
            }

            &[readonly] {
                background: ${props => props.theme?.checkout?.inputs?.background_color ?? '#fff'};
                opacity: 0.7;
            }
        }

        a, small, label {
            color: ${props => props.theme?.checkout?.color ?? '#4a505e'};
        }
    }

    #delivery-times-shipping-collapse {
        .delivery-times-calendar {
            position: relative;
            margin-bottom: 1rem;

            input {
                width: 100%;
                padding: 0.5rem 4rem 0.5rem 1rem;
                cursor: pointer;
                text-overflow: ellipsis;
                overflow: hidden;
                background: ${props => props.theme?.checkout?.inputs?.background_color ?? '#fff'};
                border: 1px solid ${props => props.theme?.checkout?.inputs?.border_color ?? '#e6e6e6'};
                color: ${props => props.theme?.checkout?.inputs?.color ?? '#4a505e'};
                border-radius: ${props => props.theme?.checkout?.inputs?.border_radius ?? '0'};

                &::placeholder {
                    color: ${props => props.theme?.checkout?.inputs?.color ?? '#4a505e'} !important;
                }

                &:focus {
                    background: ${props => props.theme?.checkout?.inputs?.background_color ?? '#fff'};
                    border: 1px solid ${props => props.theme?.checkout?.inputs?.border_color ?? '#e6e6e6'};
                    color: ${props => props.theme?.checkout?.inputs?.color ?? '#4a505e'};
                }

                &[readonly] {
                    background: ${props => props.theme?.checkout?.inputs?.background_color ?? '#fff'};
                }
            }

            i {
                position: absolute;
                right: 1rem;
                top: 50%;
                transform: translateY(-50%);
                font-size: 1.8rem;
                color: ${props => props.theme?.checkout?.inputs?.color ?? '#4a505e'};
                cursor: pointer;
            }
        }
    }

    #total-estimate-collapse {
        input {
            background: ${props => props.theme?.checkout?.inputs?.background_color ?? '#fff'};
            border: 1px solid ${props => props.theme?.checkout?.inputs?.border_color ?? '#e6e6e6'};
            color: ${props => props.theme?.checkout?.inputs?.color ?? '#4a505e'};
            border-radius: ${props => props.theme?.checkout?.inputs?.border_radius ?? '0'};

            &::placeholder {
                color: ${props => props.theme?.checkout?.inputs?.color ?? '#4a505e'} !important;
            }

            &:focus {
                background: ${props => props.theme?.checkout?.inputs?.background_color ?? '#fff'};
                border: 1px solid ${props => props.theme?.checkout?.inputs?.border_color ?? '#e6e6e6'};
                color: ${props => props.theme?.checkout?.inputs?.color ?? '#4a505e'};
            }
        }

        a, label {
            color: ${props => props.theme?.checkout?.color ?? '#4a505e'};
        }

        > .form-group {
            display: flex;
            gap: 1rem;
        }

        label {
            margin: 0;
        }
    }

    #employee-shipping-collapse {
        .loader {
            text-align: center;
            color: ${props => props.theme?.checkout?.color ?? '#4a505e'};
            opacity: 0.7;
        }

        .input-select .vs__search::placeholder,
        .input-select .vs__dropdown-toggle,
        .input-select .vs__dropdown-menu {
            background: ${props => props.theme?.checkout?.inputs?.background_color ?? '#fff'};
            border: 1px solid ${props => props.theme?.checkout?.inputs?.border_color ?? '#e6e6e6'};
            color: ${props => props.theme?.checkout?.color ?? '#4a505e'};
        }

        .input-select .vs__search::placeholder {
            font-size: 1.2rem;
        }

        .input-select .vs__search {
            padding: 3px 7px;
        }

        .input-select .vs__dropdown-toggle {
            border-radius: ${props => props.theme?.checkout?.inputs?.border_radius ?? '0'};
        }

        .input-select .vs__clear,
        .input-select .vs__open-indicator {
            fill: ${props => props.theme?.checkout?.color ?? '#4a505e'};
            opacity: 0.7;
        }
    }
`

export const CCartDiscount = styled.div`
    h4 {
        color: ${props => props.theme?.checkout?.subtitle?.color ?? '#2b2b2d'};
    }

    .input-group-append {
        margin-left: 0px;
    }

    input {
        background: ${props => props.theme?.checkout?.inputs?.background_color ?? '#fff'};
        border: 1px solid ${props => props.theme?.checkout?.inputs?.border_color ?? '#e6e6e6'};
        color: ${props => props.theme?.checkout?.inputs?.color ?? '#4a505e'};
        border-radius: ${props => props.theme?.checkout?.inputs?.border_radius ?? '0'} !important;

        &::placeholder {
            color: ${props => props.theme?.checkout?.inputs?.color ?? '#4a505e'} !important;
        }

        &:focus {
            background: ${props => props.theme?.checkout?.inputs?.background_color ?? '#fff'};
            border: 1px solid ${props => props.theme?.checkout?.inputs?.border_color ?? '#e6e6e6'};
            color: ${props => props.theme?.checkout?.inputs?.color ?? '#4a505e'};
        }
    }
`

export const CCardTemplate = styled.div`
    border: 1px solid ${props => props.theme?.checkout?.border_color ?? '#ddd'};
    background-color: transparent;

    .card-body {
        legend {
            color: ${props => props.theme?.checkout?.subtitle?.color ?? '#2b2b2d'};
        }

        .radio-group {
            border: 1px solid ${props => props.theme?.checkout?.border_color ?? '#ddd'};

            .forma-conteiner {
                color: ${props => props.theme?.checkout?.color ?? '#4a505e'};
            }
        }

        .content-payment {
            .form-group {
                margin-bottom: 1rem;

                &:first-child {
                    margin-top: 1rem;
                }
            }

            label {
                color: ${props => props.theme?.checkout?.color ?? '#4a505e'};
                margin-bottom: 0;
                font-size: 1.35rem;
            }

            input, select {
                background: ${props => props.theme?.checkout?.inputs?.background_color ?? '#fff'};
                border: 1px solid ${props => props.theme?.checkout?.inputs?.border_color ?? '#e6e6e6'};
                color: ${props => props.theme?.checkout?.inputs?.color ?? '#4a505e'};
                border-radius: ${props => props.theme?.checkout?.inputs?.border_radius ?? '0'} !important;

                &::placeholder {
                    color: ${props => props.theme?.checkout?.inputs?.color ?? '#4a505e'} !important;
                }

                &:focus {
                    background: ${props => props.theme?.checkout?.inputs?.background_color ?? '#fff'};
                    border: 1px solid ${props => props.theme?.checkout?.inputs?.border_color ?? '#e6e6e6'};
                    color: ${props => props.theme?.checkout?.inputs?.color ?? '#4a505e'};
                    outline: none;
                }
            }
        }
    }

    .card-footer {
        background-color: ${props => props.theme?.checkout?.background_color ?? '#fbfbfb'};
        border-top: 1px solid ${props => props.theme?.checkout?.border_color ?? '#ddd'};

        h3 {
            color: ${props => props.theme?.checkout?.subtitle?.color ?? '#2b2b2d'};
        }
    }
`

export const CCartTableContainer = styled.div`
    .table.table-cart tr td {
        border-top: 0px solid ${props => props.theme?.checkout?.border_color ?? '#ccc'};
        color: ${props => props.theme?.checkout?.color ?? '#4a505e'};

        a.btn-remove {
            color: ${props => props.theme?.checkout?.color ?? '#4a505e'};
        }

        .product-image-container {
            width: 100%;
            display: flex;
            justify-content: center;


            a.product-image img {
                max-height: 200px;
                object-fit: contain;
            }
        }
        .link-pdf-additional {
            color: ${props => props.theme?.checkout?.color ?? '#4a505e'};
        }
    }

    .product-row {
        border-top: 1px solid ${props => props.theme?.checkout?.border_color ?? '#ccc'};
    }

    thead {
        th {
            color: ${props => props.theme?.checkout?.color ?? '#4a505e'};

            &.qty-col {
                min-width: 120px;
            }
        }
    }

    tfoot {
        border-top: 1px solid ${props => props.theme?.checkout?.border_color ?? '#ccc'};

        td {
            label {
                color: ${props => props.theme?.checkout?.color ?? '#4a505e'};
            }

            &.total-checkout {
                width: 20rem;
                max-width: 100%;

                span {
                    display: block;
                    font-size: 1.6rem;

                    strong {
                        font-size: 1.8rem;
                    }
                }
            }
        }
    }

    h1 {
        font-size: 1.8rem;
        margin-bottom: 0;

        a {
            color: ${props => props.theme?.checkout?.color ?? '#4a505e'};
        }
    }

    h5 {
        color: ${props => props.theme?.checkout?.color ?? '#4a505e'};
        margin-bottom: 0;
    }

    .purchase-message {
        font-size: 1.7rem;
        font-weight: 700;
        text-align: center;
        color: ${props => props.theme?.checkout?.color ?? '#4a505e'};
        display: block;
    }
`

export const CProgressBar = styled.ul`
    li {
        &:before {
            background-color: ${props => props.theme?.checkout?.bar_progress?.background_color ?? '#e4e4e4'};
        }

        span {
            color: ${props => props.theme?.checkout?.bar_progress?.color_label ?? '#ccc'};

            &:before {
                background-color: ${props => props.theme?.checkout?.bar_progress?.background_color ?? '#e4e4e4'};
            }

            &:after {
                background: ${props => props.theme?.background_color_site ?? '#fff'};
                color: ${props => props.theme?.checkout?.bar_progress?.color_stage ?? '#777'};
            }
        }

        &.active {
            &:before {
                background-color: ${props => props.theme?.checkout?.bar_progress?.background_color_active ?? '#ff5501'};
            }

            span {
                color: ${props => props.theme?.checkout?.bar_progress?.color_label_active ?? '#000'};

                &:before {
                    background-color: ${props => props.theme?.checkout?.bar_progress?.background_color_active ?? '#ff5501'};
                }
            }
        }
    }
`

export const CRegistrationForm = styled.form`
    width: 100%;

    h2 {
        margin-bottom: 20px;
        margin-top: 0.7rem;
        text-transform: uppercase;
        color: ${props => props.theme?.titles_site_color ?? '#2b2b2d'};
    }

    .form-group {
        margin-bottom: 0rem;
    }

    label {
        margin-bottom: 1px;
    }

    input {
        height: 4rem;
    }
`
